/**
 * Low-level Electron environment detection.
 *
 * Keep this module limited to renderer/preload availability checks. Portable
 * runtime capabilities belong in nestAPIs/capabilities.
 */

export const ELECTRON_BRIDGE_VERSION = 3

export const hasElectronIpc = () => typeof window !== "undefined" && window.wildlarkAPI !== undefined

export async function logElectronBridgeCompatibility(): Promise<void> {
    const runtime = window.wildlarkAPI?.runtime
    if (!runtime) {
        console.warn("[WildLark] Electron bridge version is unavailable; continuing startup")
        return
    }

    try {
        const info = await runtime.info()
        warnOnElectronBridgeVersionMismatch(info.bridgeVersion, info.appVersion)
    } catch (error) {
        console.warn("[WildLark] Electron bridge version check failed; continuing startup", error)
    }
}

export function warnOnElectronBridgeVersionMismatch(value: unknown, appVersion?: unknown): void {
    if (value === ELECTRON_BRIDGE_VERSION) return

    console.warn("[WildLark] Electron bridge version differs; continuing startup", {
        rendererBridgeVersion: ELECTRON_BRIDGE_VERSION,
        desktopBridgeVersion: value,
        desktopAppVersion: appVersion,
    })
}
